import state from '@/store/modules/app/state'
import actions from '@/store/modules/app/actions'
import mutations from '@/store/modules/app/mutations'
import getters from '@/store/modules/app/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
